import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface ListingVideoUploadRecord {
  url: string;
  contentType: string;
  expires: string;
  videoId: number;
  videoUuid: string;
}

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingVideoUploadRecord>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/videos/request`,
  );
